import get from 'lodash/get';

export const getUserId = (state) => {
    const user = state.app.user;

    return user ? user.publicId : '';
};

/**
 * Determines if a user has an active membership subscription. This does not
 * guarantee that a Membership fee discount is applied to the Order. For that,
 * use `selectors/order.js:hasMemberDiscount`
 * @param {Object} state the application Redux state
 * @returns {Boolean} true when the user is subscribed to Membership as determined by hydration
 */
export const isAttendeeMember = (state) =>
    get(state, 'app.user.isAttendeeMember', false);

export const isUserLoggedIn = (state) => {
    const user = state.app.user;

    return Boolean(user && !user.hasLoggedOut && user.publicId);
};
